<template>
  <div>
    <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WKG9TGV"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe
    ></noscript>
    <div class="container-fluid px-0">
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 px-0 bg-bee">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="thanks">
                  <div class="text-center">
                    <a href="/">
                      <img
                        class="thanks__logo"
                        src="../assets/images/logo.svg"
                        alt
                      />
                    </a>
                  </div>
                  <h1 class="thanks__headline">
                    Dziękujemy, że wspólnie z Tobą możemy pomagać owadom zapylającym!
                  </h1>
                  <div class="thanks__content">
                    Dołączasz do grona Pszczelich Bohaterów i Bohaterek! Swój imienny certyfikat pszczelego bohaterstwa możesz pobrać <A href='https://certyfikat.adoptujpszczole.pl'>TUTAJ</a><br /><br />
                    Zaproś do adopcji pszczół swoich bliskich i znajomych -
                    pokaż im, jak fajne jest pomaganie pszczołom, motylom i
                    innym zapylaczom.
                  </div>
                  <div class="thanks__share py-4">
                    Udostępnij stronę:
                  </div>
                  <div class="d-flex justify-content-center">
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https%3A//adoptujpszczole.pl/?fundraiser=ap9tpfb"
                    >
                      <img
                        class="thanks__sm"
                        src="../assets/images/fb.png"
                        alt="Udostępnij na Facebook"
                    /></a>
                    <a
                      href="https://twitter.com/intent/tweet?url=&text=Zr%C3%B3bmy%20razem%20co%C5%9B%20ekstra%20dla%20pszcz%C3%B3%C5%82%2C%20motyli%20i%20innych%20zapylaczy!%20Tw%C3%B3rzmy%20Polsk%C4%99%2C%20w%20kt%C3%B3rej%20mog%C4%85%20bezpiecznie%20%C5%BCy%C4%87%20i%20pracowa%C4%87%20dla%20naszego%20wsp%C3%B3lnego%20dobra%3A%20https%3A%2F%2Fact.gp%2Fadoptujtt%20%23adoptujpszczole"
                    >
                      <img
                        class="thanks__sm"
                        src="../assets/images/tt.png"
                        alt="Udostępnij na Twitterze"
                    /></a>
                  </div>
                </div>
              </div>
            </div>
            <FooterGrass />
          </div>
        </div>
        <div class="order-1 order-lg-1 col-lg-5 px-0">
          <video
            class="form__video d-none d-lg-block"
            autoplay
            loop
            muted
            src="../assets/video/tlo-ap9.mp4"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterGrass from "@/components/FooterGrass.vue";
export default {
  name: "ThanksSinglePlus",
  title: " Potwierdzenie zamówienia",
  data() {
    return {
      title: "ThanksSinglePlus",
    };
  },
  components: {
    FooterGrass,
  },
  mounted() {

    let fbScript = document.createElement("script");
    fbScript.text = `
      let purchaseAmount = new URLSearchParams(location.search).get("a");      
      let eventId = new URLSearchParams(location.search).get("p");
      fbq('track', 'Purchase', {
        value: purchaseAmount,
        currency: 'PLN'
      }, {eventID: eventId });
    `;
    document.body.appendChild(fbScript);


    let gtmScript = document.createElement("script");

    gtmScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-WKG9TGV');`;

    document.body.appendChild(gtmScript);

    let gtmScript2 = document.createElement("script");

    gtmScript2.text = `let amount = new URLSearchParams(location.search).get("a");
  let paymentId = new URLSearchParams(location.search).get("p");
  let beeNum = amount/2;
  dataLayer.push({
    "event": "transactionSuccess",
    "ecommerce": {
      "currencyCode": "PLN",
      "purchase": {
        "actionField": {
          "id": paymentId,
          "affiliation": "ap9",
          "revenue": amount,
          "action": "purchase"
        },
        "products": [
          {
            "name": "ap9",
            "id": "45",
            "price": amount,
            "brand": "GPPL",
            "quantity": "1"
          }
        ]
      }
    },
    "officeName": "Poland",
    "gBasket": "Good Life",
    "gScope": "Local",
    "gLocalCampaign": "ap9",
    "gLocalPlatform": "Goddess",
    "gAmount": amount,
    "gPageName": "ap9",
    "gPagetype": "Donation",
    "NewsletterSignup": "Y",
    "recurring": 0,
  });
        window.dataLayer = window.dataLayer || [];
      dataLayer.push({
      'event': 'transactionComplete',
      'transactionId': paymentId,
      'transactionAffiliation': '',
      'transactionTotal': amount,
      'transactionTax': 0,
      'transactionShipping': 0,
      'transactionProducts': [{
      'sku': 'AP9',
      'name': 'Adopcja jednorazowa plus',
      'category': '',
      'price': amount,
      'quantity': beeNum,
      }],
      'customer': 'true',
      'successPayment': '1',
      'currencyCode': 'PLN'
      });
  `;
    gtmScript2.setAttribute("defer", "");
    document.body.appendChild(gtmScript2);
  },
};
</script>
